import React, { useMemo, useState } from "react";
import PageShell from "@/components/site/PageShell";
import PageHeader from "@/components/site/PageHeader";
import RadarItem from "@/components/site/RadarItem";
import { useRadar } from "@/components/home/RadarPreview";
import { Container, Reveal } from "@/components/site/ui";
import { RADAR, IMG } from "@/content/site";

const Chip = ({ active, onClick, children, testId }) => (
    <button
        type="button"
        onClick={onClick}
        data-testid={testId}
        className={`font-sans text-[10.5px] uppercase tracking-[0.18em] rounded-full px-4 py-2 border transition-colors ${active ? "bg-[#C7A659] border-[#C7A659] text-[#0A1812]" : "border-[#234135] text-[#B0B6A6] hover:border-[#C7A659] hover:text-[#F2EFE5]"}`}
    >
        {children}
    </button>
);

const RadarPage = () => {
    const { data, isLoading } = useRadar(200);
    const [cat, setCat] = useState(null);
    const items = useMemo(() => (data || []).filter((i) => !cat || i.category === cat), [data, cat]);

    return (
        <PageShell path="/radar" title="Radar" sections={["header", "radar-lista"]}>
            <PageHeader testId="radar-page-header" eyebrow={RADAR.eyebrow} title={RADAR.title} lead={RADAR.lead} img="/img/radar-mapa.jpg" veil={0.5} alt="Mapa-múndi escuro com pontos e linhas douradas indicando transformações simultâneas em diferentes regiões" />
            <section data-section-id="radar-lista" className="pb-28">
                <Container className="grid grid-cols-1 lg:grid-cols-12 gap-12">
                    <aside className="lg:col-span-4">
                        <div className="lg:sticky lg:top-28">
                            <p className="font-sans font-light text-[13.5px] leading-[1.75] text-[#B0B6A6] border-l-2 border-[#C7A659] pl-5">{RADAR.aviso}</p>
                            <p className="mt-10 font-sans text-[10px] uppercase tracking-[0.28em] text-[#7E8978] mb-4">Filtrar por tema</p>
                            <div className="flex flex-wrap gap-2">
                                <Chip active={!cat} onClick={() => setCat(null)} testId="radar-filter-todos">Todos</Chip>
                                {Object.entries(RADAR.categorias).map(([k, v]) => (
                                    <Chip key={k} active={cat === k} onClick={() => setCat(k)} testId={`radar-filter-${k}`}>{v}</Chip>
                                ))}
                            </div>
                        </div>
                    </aside>
                    <Reveal className="lg:col-span-8" delay={100}>
                        <div data-testid="radar-list">
                            {isLoading && <p className="font-sans text-[13px] text-[#7E8978]">Carregando…</p>}
                            {items.map((it) => <RadarItem key={it.id} item={it} full />)}
                            {data && items.length === 0 && (
                                <p data-testid="radar-empty" className="py-10 border-t border-[#1B3025] font-serif italic text-[18px] text-[#D7D1BF]">
                                    {cat ? "Nenhuma leitura neste tema por enquanto." : RADAR.vazio}
                                </p>
                            )}
                        </div>
                    </Reveal>
                </Container>
            </section>
        </PageShell>
    );
};

export default RadarPage;
